import { createApp } from 'vue';
import TarToZipConverter from '@/Components/TarToZipConverter.vue';
import '@styles/app.css';

createApp(TarToZipConverter).mount('#tar-to-zip-converter');
